module.exports = __webpack_public_path__ + "img/logo-sign2.ac9870a1.png";